<template>
  <div class="header w-nav">
    <div class="header-container">
      <div class="header-part">
        <router-link to="/" class="brand w-nav-brand">
          <div class="logo">
            <ZubmillLogoSmallIcon />
          </div>
        </router-link>

        <NewOrderLink v-if="canI('createNewOrder') && $route.name !== 'new-order'" />
      </div>

      <div class="header-part">
        <!-- <Technician v-if=" $route.name === 'new-order'" /> -->
        <Balance v-if="canI('seeBalance')" />
        <UserMenu />
      </div>
    </div>
  </div>
</template>

<script>
  import ZubmillLogoSmallIcon from '@/icons/zubmill-logo-small.svg';
  import Balance from '@/containers/header/Balance';
  import UserMenu from '@/containers/header/UserMenu';
  import NewOrderLink from '@/containers/header/NewOrderLink';
  // import Technician from '@/containers/header/Technician';
  import canI from '@/utils/access';

  export default {
    name: 'Header',
    components: {
      NewOrderLink,
      UserMenu,
      Balance,
      ZubmillLogoSmallIcon,
      // Technician,
    },
    methods: {
      canI,
    },
  };
</script>

<style lang="scss">
  .profile-item:hover .icon-16px svg path{
    fill: #1BA6DF !important;
  }
</style>
